import { Search, X } from "lucide-react";
import { type InputHTMLAttributes, forwardRef } from "react";
import { IconButton } from "../atoms/IconButton";
import { Input } from "../atoms/Input";
import { cn } from "../lib/cn";

export interface SearchFieldProps
	extends Omit<InputHTMLAttributes<HTMLInputElement>, "onChange"> {
	value: string;
	onChange: (value: string) => void;
	placeholder?: string;
	onClear?: () => void;
	className?: string;
}

const SearchField = forwardRef<HTMLInputElement, SearchFieldProps>(
	(
		{ value, onChange, placeholder = "Search...", onClear, className, ...rest },
		ref,
	) => {
		const showClear = Boolean(onClear) && value.length > 0;

		return (
			<div className={cn("relative flex items-center", className)}>
				<Search
					className="pointer-events-none absolute left-3 h-4 w-4 text-mutedForeground"
					aria-hidden="true"
				/>
				<Input
					ref={ref}
					value={value}
					onChange={(e) => onChange(e.target.value)}
					placeholder={placeholder}
					className="pl-9 pr-9"
					{...rest}
				/>
				{showClear && (
					<IconButton
						aria-label="Clear search"
						size="sm"
						className="absolute right-1"
						onClick={onClear}
					>
						<X className="h-3 w-3" aria-hidden="true" />
					</IconButton>
				)}
			</div>
		);
	},
);
SearchField.displayName = "SearchField";

export default SearchField;
export { SearchField };
